<template>
  <div>
    <div id="stickyline"></div>

    <p />
    <main>
      <div class="container-fixed offset-top-16 offset-bottom-17">
        <VSpinner />
      </div>
    </main>
  </div>
</template>

<script>
import VSpinner from '@/components/Spinner';

export default {
  name: 'LayoutLoading',

  components: {
    VSpinner,
  },
};
</script>
